module.exports = __webpack_public_path__ + "img/dash-bullet.ee0812d0.svg";